<template>
	<div id="chat-app">

		<div class="content-area__content">
			<div id="chat-app-container" class="border border-solid border-grey-light rounded relative overflow-hidden">
				<vs-sidebar class="items-no-padding" parent="#chat-app-container" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

					<!-- USER PROFILE SIDEBAR -->
					<!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" :user="userProfile" class="user-profile-container" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->
					<user-profile :active="activeProfileSidebar" :user="selectedUserProfile" class="user-profile-container" @closeProfileSidebar="closeProfileSidebar"></user-profile>

					<div class="chat__profile-search flex p-4">
						<div class="relative inline-flex">
							<!-- <vs-avatar class="m-0" :src="activeUserImg" size="40px" @click="showProfileSidebar(activeUserId)" /> -->
							<!-- <img class="m-0" :src="activeUserImg"  @click="showProfileSidebar(activeUserId)" /> -->
							<img
								:src="activeUserImg"
								@error="onLoadErrorImageHandler"
								@click="showProfileSidebar(userProfile)"
								alt="profile_image" width="40" height="40" 
								class="rounded-full cursor-pointer block">
							<!-- <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b" :class="'bg-' + getStatusColor(true)"></div> -->
							<div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b bg-success"></div>
						</div>
						<vs-input icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full no-icon-border" placeholder="Buscar o iniciar una conversación" v-model="searchQuery"/>
					</div>

					<vs-divider class="border-grey-light m-0" />
					<VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="settings">

						<!-- ACTIVE CHATS LIST -->
						<!-- <div class="chat__chats-list mb-8">
							<h3 class="text-primary mb-5 px-4">Mis Conversaciones</h3>
							<ul class="chat__active-chats bordered-items">
								<li class="cursor-pointer" v-for="(contact, index) in sorted" :key="index" @click="updateActiveChatUser(contact.id)">
									<chat-contact :contact="contact" :lastMessaged="chatLastMessaged(contact.id).time" :unseenMsg="chatUnseenMessages(contact.id)" :isActiveChatUser="isActiveChatUser(contact.id)"></chat-contact>
								</li>
							</ul>
						</div> -->

						<!-- ADMINISTRATIVOS LIST -->
						<div class="chat__contacts">
							<h3 class="text-primary mb-5 px-4">Adminstrativos</h3>
							<ul class="chat__contacts bordered-items">
								<li 
									class="cursor-pointer"
									v-for="contact in (searchContact.length != 0) ? administrativosSearch : administrativos" 
									:key="contact.idUsuario" @click="updateActiveChatUser(contact)">
										<chat-contact :contact="contact" :isActiveChatUser="isActiveChatUser(contact)"></chat-contact>
								</li>	
							</ul>
						</div>

						<!-- PROFESORES LIST -->
						<div class="chat__contacts">
							<h3 class="text-primary mb-5 px-4">Profesores</h3>
							<ul class="chat__contacts bordered-items">
								<li 
									class="cursor-pointer" 
									v-for="contact in (searchContact.length != 0) ? profesoresSearch : profesores" 
									:key="contact.id" @click="updateActiveChatUser(contact)">
									<chat-contact :contact="contact" :isActiveChatUser="isActiveChatUser(contact)"></chat-contact>
								</li>
							</ul>
						</div>


						<!-- ALUMNOS LIST -->
						<div class="chat__contacts">
							<h3 class="text-primary mb-5 px-4">Alumnos</h3>
							<ul class="chat__contacts bordered-items">
								<li
									class="cursor-pointer"
									v-for="contact in (searchContact.length != 0) ? alumnosSearch : alumnos"
									:key="contact.id" @click="updateActiveChatUser(contact)">
									<chat-contact :contact="contact" :isActiveChatUser="isActiveChatUser(contact)"></chat-contact>
								</li>
							</ul>
						</div>
					</VuePerfectScrollbar>
				</vs-sidebar>

				<!-- RIGHT COLUMN -->
				<div class="chat__bg app-fixed-height chat-content-area border border-solid border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null}">
					<template v-if="activeChatUser">
						<div class="chat__navbar">
							<chat-navbar :isSidebarCollapsed="!clickNotClose" :user="activeChatUser" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="updateUserProfileId" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
						</div>
						<VuePerfectScrollbar class="chat-content-scroll-area border border-solid border-grey-light" :settings="settings" ref="chatLogPS">
							<div class="chat__log" ref="chatLog">
								<chat-log :user="activeChatUser" :chatMsgs="mensajes" v-if="activeChatUser"></chat-log>
							</div>
						</VuePerfectScrollbar>
						<div class="chat__input flex p-4 bg-white">
							<vs-input class="flex-1" placeholder="Escribe tu mensaje" v-model="typedMessage" @keyup.enter="sendMsg" />
							<vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg">Enviar</vs-button>
						</div>
					</template>
					<template v-else>
						<div class="flex flex-col items-center">
							<feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
							<h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="toggleChatSidebar(true)">Iniciar Conversación</h4>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import contacts from './contacts'
import ChatContact from "./ChatContact.vue"
import UserProfile from "./UserProfile.vue"
import ChatNavbar from './ChatNavbar.vue'
import ChatLog from './ChatLog.vue'

export default{
	name: 'vx-sidebar',
	data() {
		return {
			active: true,
			isHidden: false,
			contacts: [],
			administrativos:[],
			administrativosSearch:[],
			profesores: [],
			profesoresSearch: [],
			alumnos: [],
			alumnosSearch:[],
			userProfile: {
				nombre: '',
				imagen: ''
			},
			selectedUserProfile: {
				nombre: '',
				imagen: ''
			},
			mensajes:[],
			searchContact: "",
			activeProfileSidebar: false,
			activeChatUser: null,
			activeChatUserObject: null,
			userProfileId: -1,
			typedMessage: "",
			isChatPinned: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.30,
			},
			clickNotClose: true,
			isChatSidebarActive: true,
			windowWidth: window.innerWidth,
		}
	},
	computed: {
		chatLastMessaged() {
			return (userId) => this.$store.getters['chat/chatLastMessaged'](userId);
		},
		chatUnseenMessages() {
			return (userId) => {
				const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](userId);
				if(unseenMsg) return unseenMsg
			};
		},
		sorted() {
			return this.chats.slice().sort((x,y) => {
				const xId = x.id;
				const yId = y.id;
				const chatDataX = this.$store.getters['chat/chatDataOfUser'](xId);
				const chatDataY = this.$store.getters['chat/chatDataOfUser'](yId);
				return (chatDataY.isPinned - chatDataX.isPinned)
			})
		},
		activeUserId() {
			return this.$store.state.AppActiveUser.id;
		},
		activeUserImg() {
			// return this.$store.state.AppActiveUser.img;
			return this.userProfile.imagen;
		},
		activeUserStatus() {
			return this.$store.state.AppActiveUser.status;
		},
		getStatusColor() {
			return (isActiveUser) => {
				const userStatus = this.getUserStatus(isActiveUser)

				if(userStatus == "online"){
					return "success"
				}else if(userStatus == "do not disturb"){
					return "danger"
				}else if(userStatus == "away"){
					return "warning"
				}else{
					return "grey"
				}
			}
		},
		chats() {
			return this.$store.getters['chat/chats'];
		},
		chatContacts() {
			return this.$store.getters['chat/chatcontacts'];
		},
		searchQuery: {
			get() {
				// return this.$store.state.chat.chatSearchQuery;
				return this.searchContact;
			},
			set(val) {
				this.searchContact = val;
				if (this.searchContact.length === 0) {
					this.administrativosSearch = [];
					this.profesoresSearch = [];
					this.alumnosSearch = [];
				}else{
					this.administrativosSearch = [];
					this.profesoresSearch = [];
					this.alumnosSearch = [];
					this.administrativosSearch = this.administrativos.filter(contact=>{
						return contact.nombre.toLowerCase().includes(this.searchContact.toLowerCase());
					});
					this.profesoresSearch = this.profesores.filter(contact=>{
						return contact.nombre.toLowerCase().includes(this.searchContact.toLowerCase());
					});
					this.alumnosSearch = this.alumnos.filter(contact=>{
						return contact.nombre.toLowerCase().includes(this.searchContact.toLowerCase());
					});
				}
				// this.$store.dispatch('chat/setChatSearchQuery', val);
			}
		},
	},
	methods: {
		isActiveChatUser(contact) {
			// console.log('isActiveUser')
			// return (contact) => {
			// 	if (this.activeChatUser != null) {
			// 		return contact.idUsuario == this.activeChatUser.idUsuario
			// 	}else{
			// 		return false;
			// 	}
			// }
			// console.log(contact)
			// return contact => (this.activeChatUser != null) ? contact.idUsuario == this.activeChatUser.idUsuario : false;
			return this.activeChatUser != null ? contact.idUsuario == this.activeChatUser.idUsuario : false;
		},
		getUserStatus(isActiveUser) {
			return (isActiveUser) ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status;
		},
		getProfile(){
			fetch(`${this.$BASE.baseUrl}api/obtenerPerfil`, {
				method: 'GET',
				headers: {'Authorization': sessionStorage.getItem('token')}
			})
			.then(rs => rs.json())
			.catch(error => console.log('error:', error))
			.then(rs => {
				// console.log(rs)
				this.$_userSessionMixin_checkSession(rs.status);
				if(rs.status == 200){
					this.userProfile.nombre = rs.result.nombre;
					this.userProfile.imagen = this.$BASE.baseUrl+rs.result.imagen;
					this.userProfile.activeUser = true;
				}
			});
		},
		getContacts(){
			fetch(`${this.$BASE.baseUrl}api/ObtenerUsuariosChat`,{
				method:'GET',
				headers:{
					'Authorization': sessionStorage.getItem('token')
				}
			})
			.then(rs=>rs.json())
			.catch(error=>console.log('Error: ', error))
			.then(rs=>{
				this.$_userSessionMixin_checkSession(rs.status);
				if (rs.status === 200) {
					// console.log(rs)
					rs.result.forEach(contactGroup=>{
						if (contactGroup.nivel === 'Administradores'){
							contactGroup.usuarios.forEach(contacto=>{
								contacto.imagen = this.$BASE.baseUrl+contacto.imagen;
								this.administrativos.push(contacto)
							})
						}
						if (contactGroup.nivel === 'Profesores'){
							contactGroup.usuarios.forEach(contacto=>{
								contacto.imagen = this.$BASE.baseUrl+contacto.imagen;
								this.profesores.push(contacto)
							})
						}
						if (contactGroup.nivel === 'Alumnos'){
							contactGroup.usuarios.forEach(contacto=>{
								contacto.imagen = this.$BASE.baseUrl+contacto.imagen;
								this.alumnos.push(contacto)
							})
						}
					})
				}
			})
		},
		getChatLog(idUsuario){
			// console.log('getChatLog')
			fetch(`${this.$BASE.baseUrl}api/ObtenerMensajes/${idUsuario}`, {
				method:'GET',
				headers:{
					'Authorization': sessionStorage.getItem('token')
				}
			})
			.then(rs=>rs.json())
			.catch(error=>console.log('Error: ', error))
			.then(rs=>{
				// console.log(rs)
				if (rs.status === 200) {
					this.mensajes = rs.result;
				}
			})
		},
		closeProfileSidebar(value) {
			this.activeProfileSidebar = value
		},
		onLoadErrorImageHandler(event){
			event.target.src = require(`@/assets/images/portrait/small/profile_pic.png`);
		},
		updateUserProfileId(user) {
			// this.userProfileId = userId;
			// console.log(user)
			this.selectedUserProfile = user;
			this.activeProfileSidebar = !this.activeProfileSidebar;
		},
		updateActiveChatUser(contact) {
			// this.activeChatUser = null;
			// this.activeChatUserObject = null;
			this.activeChatUser = contact;
			// this.activeChatUserObject = contact;
			this.getChatLog(this.activeChatUser.idUsuario);
			this.isActiveChatUser(contact);
			// if(this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)) {
			// 	this.$store.dispatch('chat/markSeenAllMessages', 1)
			// }
			// let chatData = this.$store.getters['chat/chatDataOfUser'](this.activeChatUser);
			// if(chatData) this.isChatPinned = chatData.isPinned;
			// else this.isChatPinned = false
			// this.toggleChatSidebar();
		},
		showProfileSidebar(user) {
			// this.userProfileId = userId;
			console.log(user)
			this.selectedUserProfile = user;
			this.activeProfileSidebar = !this.activeProfileSidebar;
		},
		sendMsg() {
			if(!this.typedMessage) return
			// const payload = {
			// 	isPinned: this.isChatPinned,
			// 	'msg': {
			// 		'textContent': this.typedMessage,
			// 		'time': String(new Date()),
			// 		'isSent': true,
			// 		'isSeen': false,
			// 	},
			// 	'id': this.activeChatUser
			// }
			// this.$store.dispatch('chat/sendChatMessage', payload)
			// console.log(this.activeChatUser)
			let msgObject={
				idUsuarioRecibe:this.activeChatUser.idUsuario,
				mensaje:this.typedMessage
			}
			fetch(`${this.$BASE.baseUrl}api/AgregarMensaje`,{
				method:'POST',
				headers:{
					'Authorization':sessionStorage.getItem('token'),
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(msgObject)
			})
			.then(rs=>rs.json())
			.catch(error=>console.log('Error: ',error))
			.then(rs=>{
				console.log(rs);
				this.updateActiveChatUser(this.activeChatUser);
			})
			this.typedMessage = '';
			setTimeout(() => {
				this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
			}, 50)
		},
		toggleIsChatPinned(value) {
			this.isChatPinned = value;
		},
		handleWindowResize(event) {
			this.windowWidth = event.currentTarget.innerWidth;
			this.setSidebarWidth();
		},
		setSidebarWidth() {
			if(this.windowWidth < 1200) {
				this.isChatSidebarActive = this.clickNotClose = false;
			}else {
				this.isChatSidebarActive = this.clickNotClose = true;
			}
		},
		toggleChatSidebar(value = false) {
			if(!value && this.clickNotClose) return
			this.isChatSidebarActive = value;
		},
		destroyPS() {
			this.$refs.chatLogPS.__uninit();
		},
	},
	components: {
		VuePerfectScrollbar,
		ChatContact,
		UserProfile,
		ChatNavbar,
		ChatLog,
	},
	created() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.handleWindowResize);
		})
		this.setSidebarWidth();
		this.getProfile();
		this.getContacts();
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleWindowResize)
	},
}
</script>

<style lang="scss"  src="../css/chat.scss"></style>
